module.exports = __webpack_public_path__ + "static/media/4D.5347d506.svg";